module.exports = __webpack_public_path__ + "img/85.c4b86656.jpg";